import { faArrowRight } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { getDateRangeTitles } from "../../helpers/dayjsSetup";

export default function DetentionReconciliation({ data }) {
    const dateRangeTitles = getDateRangeTitles();
    const navigate = useNavigate();
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="flex justify-between items-baseline mb-4">
                <span className="text-[18px] font-semibold">
                    Detention Reconciliation
                </span>
                <span className="text-[14px] text-primary hover:cursor-pointer" onClick={() => navigate("/detention")}>
                    See more <FontAwesomeIcon icon={faArrowRight} />
                </span>
            </div>
            <div className="flex justify-center mb-6">
                <Progress
                    type="circle"
                    percent={100}
                    size="default"
                    strokeColor="#87c9c4"
                    trailColor="#e6fffa"
                    strokeWidth={6}
                    format={() => (
                        <div className="flex flex-col items-center">
                            <span className="text-sm text-gray-500">Current</span>
                            <div className="text-lg font-semibold text-black">
                                ${data?.current?.toLocaleString()}
                            </div>
                        </div>
                    )}
                />
            </div>
            <div className="grid grid-cols-2 gap-3">
                <MiniStat label="MTD" value={data?.monthToDate} title={dateRangeTitles?.monthToDate} />
                <MiniStat label="YTD" value={data?.financialYearToDate} title={dateRangeTitles?.financialYearToDate} />
            </div>
        </Card>
    );
}

function MiniStat({ label, value, title }) {
    return (
        <div className="bg-gray-100 rounded-lg p-2 text-center" title={title}>
            <div className="text-xs text-gray-500">
                {label}
            </div>
            <div className="text-lg font-semibold" title="Figures will be available in a later stage">
                -{/* ${value?.toLocaleString()} */}
            </div>
        </div>
    );
}